import { getJSON } from './ultile';
import {
  STORE_HOST,
  SET_HAS_LOAD_PAYTYPE,
  SET_SHOW_CHANNEL_STATUS,
  UPDATE_LOADING,
  UPDATE_SHOW_CURRENCY
} from './index';
import {
  storePayTypeList,
  setDefaultPayType,
  getStoreHrefParam
} from './storager';
import { minus, plus, times } from '@utiles/officialStore/index';
export const GET_CART_ACTION = 'get_cart';
export const SET_CART_QUANTITY_LIMIT = 'set_cart_quantity_limit';
export const UPDATE_CAN_USE_CART = 'update_can_use_cart';
export const UPDATE_CART_LIST_OF_AMOUNT = 'update_cart_list_of_amount';
export const UPDATE_SHOW_CARTLIST_STATUS = 'update_show_cartlist_status';
export const UPDATE_DELETE_ITEM = 'update_delete_item';
export const CLEAR_CART = 'clear_cart';
export const UPDATE_IS_CART = 'update_is_cart';
export const ADD_PRODUCT_TO_CART = 'add_product_to_cart';
export const SUB_PRODUCT_OF_CART = 'sub_product_of_cart';
export const SET_PRODUCT_OF_CART = 'set_product_of_cart';
export const REMOVE_PRODUCT_OF_CART = 'remove_product_of_cart';
export const LOAD_CART_PAYTYPE_LIST_DATA = 'load_cart_paytype_list_data';
export const GET_CART = 'get_cart';
export const RELOAD_CART_WAY_ACTION = 'get_cart_price_list';
export const RELOAD_WAY_CART = 'reload_way_cart';
export const SET_DELETE_POPUP = 'set_delete_popup';

export default {
  state: {
    isCart: false,
    cartList: [], // 购物车列表
    showCartList: false, // 是否显示购物车
    showDetelePopup: false, // 是否显示删除商品弹窗
    deleteItem: {},
    deleteIndex: 0,
    cartQuantityLimit: 20, // 购物车数量上限
    canUseCart: 0 // 是否能使用購物車
  },
  getters: {
    cartTotalPrice: state => {
      let totalPrice = 0;
      state.cartList.forEach(item => {
        if (item.amountLevel && item.amountLevel?.TRANS_AMOUNT) {
          totalPrice = plus(
            totalPrice,
            times(+item.amountLevel?.TRANS_AMOUNT, +item.quantity)
          );
        }
      });
      return totalPrice;
    },
    cartTotalExtraCoin: state => {
      let totalExtraCoin = 0;
      state.cartList.forEach(item => {
        if (item.amountLevel && item.amountLevel?.EXTRA_COIN) {
          totalExtraCoin = plus(
            totalExtraCoin,
            times(+item.amountLevel?.EXTRA_COIN, +item.quantity)
          );
        }
      });
      return totalExtraCoin;
    },
    cartTotalQuantity: state => {
      let totalQuantity = 0;
      state.cartList.forEach(item => {
        totalQuantity += +item.quantity;
      });
      return totalQuantity;
    },
    cartDiscountTransMount: (_state, getters, rootState) => {
      let price = getters.cartTotalPrice;
      if (!rootState.coupon.paytypeActiveCouponId) {
        return price;
      }
      let newPrice = minus(price, getters.activePaytypeCouponReductPrice);
      return newPrice.toFixed(2);
    },
    cartProductType(state) {
      let productTypes = [];
      state.cartList.forEach(item => {
        if (!productTypes.includes(item.PRODUCT_TYPE)) {
          productTypes.push(item.PRODUCT_TYPE);
        }
      });
      return productTypes.length === 1 ? productTypes[0] : 'mix';
    }
  },
  mutations: {
    [SET_DELETE_POPUP](state, status) {
      state.showDetelePopup = status;
    },
    [UPDATE_CAN_USE_CART](state, data) {
      state.canUseCart = +data.can_use_cart || false;
    },
    [SET_CART_QUANTITY_LIMIT](state, data) {
      state.cartQuantityLimit = +data.cart_quantity_limit || 20;
    },
    [UPDATE_DELETE_ITEM](state, item) {
      state.deleteItem = item;
    },
    [UPDATE_SHOW_CARTLIST_STATUS](state, status) {
      state.showCartList = status;
    },
    [UPDATE_CART_LIST_OF_AMOUNT](state, cartList) {
      state.cartList = cartList;
    },
    [CLEAR_CART](state) {
      state.cartList.splice(0, state.cartList.length);
    },
    [SUB_PRODUCT_OF_CART](state, product) {
      const cpProductId = product.CP_PRODUCT_ID || '';
      const productId = product.PRODUCT_ID || '';
      let index = -1;
      const cartLength = state.cartList.length;
      for (let i = 0; i < cartLength; i++) {
        let item = state.cartList[i];
        if (item.PRODUCT_ID == productId && item.CP_PRODUCT_ID == cpProductId) {
          index = i;
          break;
        }
      }
      if (index != -1) {
        const quantity = state.cartList[index].quantity;
        if (quantity === 1) {
          state.cartList.splice(index, 1);
          Object.assign(product, { quantity: 0 });
        } else {
          state.cartList.splice(
            index,
            1,
            Object.assign(state.cartList[index], { quantity: quantity - 1 })
          );
          Object.assign(product, { quantity: quantity - 1 });
        }
      }
    },
    [REMOVE_PRODUCT_OF_CART](state, info) {
      const cpProductId = info.CP_PRODUCT_ID || '';
      const productId = info.PRODUCT_ID || '';
      let index = -1;
      const cartLength = state.cartList.length;
      for (let i = 0; i < cartLength; i++) {
        let item = state.cartList[i];
        if (item.PRODUCT_ID == productId && item.CP_PRODUCT_ID == cpProductId) {
          index = i;
          break;
        }
      }
      if (index != -1) {
        let productItem = state.cartList[index];
        state.cartList.splice(index, 1);
        Object.assign(productItem, { quantity: 0 });
      }
    },
    [SET_PRODUCT_OF_CART](state, info) {
      const cpProductId = info.CP_PRODUCT_ID || '';
      const productId = info.PRODUCT_ID || '';
      let index = -1;
      const cartLength = state.cartList.length;
      for (let i = 0; i < cartLength; i++) {
        let item = state.cartList[i];
        if (item.PRODUCT_ID == productId && item.CP_PRODUCT_ID == cpProductId) {
          index = i;
          break;
        }
      }
      if (index != -1) {
        let productItem = state.cartList[index];
        const quantity = +info.limit;
        if (quantity >= 1) {
          state.cartList.splice(
            index,
            1,
            Object.assign(state.cartList[index], { quantity: quantity })
          );
          Object.assign(productItem, { quantity: quantity });
        } else {
          state.cartList.splice(index, 1);
          Object.assign(productItem, { quantity: 0 });
        }
      }
    },
    [ADD_PRODUCT_TO_CART](state, product) {
      const cpProductId = product.CP_PRODUCT_ID || '';
      const productId = product.PRODUCT_ID || '';
      let index = -1;
      const cartLength = state.cartList.length;
      for (let i = 0; i < cartLength; i++) {
        let item = state.cartList[i];
        if (item.PRODUCT_ID == productId && item.CP_PRODUCT_ID == cpProductId) {
          index = i;
          break;
        }
      }
      if (index != -1) {
        let num = state.cartList[index].quantity + 1;
        state.cartList.splice(
          index,
          1,
          Object.assign(state.cartList[index], { quantity: num })
        );
        Object.assign(product, { quantity: num });
      } else {
        state.cartList.push(Object.assign(product, { quantity: 1 }));
      }
    },
    [UPDATE_IS_CART](state, isCart) {
      state.isCart = isCart;
    }
  },
  actions: {
    [LOAD_CART_PAYTYPE_LIST_DATA]({ commit }) {
      let params = getStoreHrefParam();
      return new Promise(resolve => {
        getJSON(STORE_HOST + RELOAD_CART_WAY_ACTION, params).then(
          ({ errmsg, data }) => {
            if (!errmsg) {
              let allPayTypes = data.paytype_list;
              storePayTypeList(allPayTypes);
              setDefaultPayType(data.paytype_list[0]);
              commit(SET_HAS_LOAD_PAYTYPE, true);
              commit(SET_SHOW_CHANNEL_STATUS, true);
              commit(UPDATE_LOADING, false);
              resolve(true);
            } else {
              resolve(false);
            }
          }
        );
      });
    },
    [GET_CART](_context, orderId) {
      return new Promise((resolve, reject) => {
        getJSON(STORE_HOST + GET_CART_ACTION, {
          order_id: orderId
        }).then(({ errmsg, data }) => {
          if (!errmsg) {
            resolve(data);
          } else {
            reject(errmsg);
          }
        });
      });
    },
    [RELOAD_WAY_CART]({ commit }, params = {}) {
      return new Promise((resolve, reject) => {
        let param = getStoreHrefParam();
        param = { ...param, ...params };
        getJSON(STORE_HOST + RELOAD_CART_WAY_ACTION, param).then(
          ({ errmsg, data }) => {
            if (!errmsg) {
              storePayTypeList(data.paytype_list);
              setDefaultPayType(data.paytype_list[0]);
              resolve(true);
            } else {
              reject(errmsg);
            }
          }
        );
      });
    }
  }
};
